/**
 * 🚀 Course Feature i18n - Paraglide JS Native Implementation
 * 
 * Zero Runtime, Complete Type Safety!
 * Course 도메인 전용 i18n 모듈
 */ import * as m from '@paraglide/messages';
// ========== Course Basic Messages ==========
export const courseMessages = {
    // Basic course info
    title: m.course_title,
    description: m.course_description,
    price: m.course_price,
    currency: m.course_currency,
    level: m.course_level,
    beginner: m.course_beginner,
    intermediate: m.course_intermediate,
    advanced: m.course_advanced,
    allLevels: m.course_allLevels,
    multilingualHelpText: m.course_multilingualHelpText,
    // Course creation
    create: {
        success: m.course_create_success,
        error: m.course_create_error
    },
    createSuccess: m.course_createSuccess,
    createError: m.course_createError
};
// ========== Course List Messages ==========
export const courseListMessages = {
    title: m.course_courses_title,
    loading: m.course_courses_loading,
    loadMore: m.course_courses_loadMore,
    loadMoreCourses: m.course_courses_loadMore_courses,
    loadingCourses: m.course_courses_loading_courses,
    loadingRoadmaps: m.course_courses_loading_roadmaps,
    error: {
        loadFailed: m.course_courses_error_loadFailed
    },
    empty: {
        courses: m.course_courses_empty_courses,
        myCompleted: m.course_courses_empty_myCompleted,
        myInProgress: m.course_courses_empty_myInProgress,
        myPublished: m.course_courses_empty_myPublished,
        roadmaps: m.course_courses_empty_roadmaps,
        userCompleted: m.course_courses_empty_userCompleted,
        userInProgress: m.course_courses_empty_userInProgress,
        userPublished: m.course_courses_empty_userPublished
    },
    tabs: {
        completed: m.course_courses_tabs_completed,
        drafts: m.course_courses_tabs_drafts,
        inProgress: m.course_courses_tabs_inProgress,
        published: m.course_courses_tabs_published
    },
    types: {
        courses: m.course_courses_types_courses,
        roadmaps: m.course_courses_types_roadmaps
    }
};
// ========== Course Detail Messages ==========
export const courseDetailMessages = {
    loading: m.course_courseDetail_loading,
    error: m.course_courseDetail_error,
    dataError: m.course_courseDetail_dataError
};
// ========== Lecture Messages ==========
export const lectureMessages = {
    title: m.course_lecture_title,
    lecturePage: {
        accessCheck: m.course_lecture_lecturePage_accessCheck,
        courseLoading: m.course_lecture_lecturePage_courseLoading,
        courseError: m.course_lecture_lecturePage_courseError,
        lectureLoading: m.course_lecture_lecturePage_lectureLoading,
        lectureError: m.course_lecture_lecturePage_lectureError,
        noLecture: m.course_lecture_lecturePage_noLecture
    }
};
// ========== Roadmaps Messages ==========
export const roadmapsMessages = {
    loading: m.course_roadmaps_loading
};
// ========== Attachments Messages ==========
export const attachmentsMessages = {
    title: m.course_attachments_title,
    uploadTitle: m.course_attachments_uploadTitle,
    titlePlaceholder: m.course_attachments_titlePlaceholder,
    descriptionPlaceholder: m.course_attachments_descriptionPlaceholder,
    empty: m.course_attachments_empty,
    loading: m.course_attachments_loading,
    actions: {
        upload: m.course_attachments_actions_upload,
        delete: m.course_attachments_actions_delete,
        copyUrl: m.course_attachments_actions_copyUrl
    },
    messages: {
        uploadSuccess: m.course_attachments_messages_uploadSuccess,
        uploadError: m.course_attachments_messages_uploadError,
        uploadErrorPrefix: m.course_attachments_messages_uploadErrorPrefix,
        uploadingWithProgress: m.course_attachments_messages_uploadingWithProgress,
        deleteConfirm: m.course_attachments_messages_deleteConfirm,
        deleteSuccess: m.course_attachments_messages_deleteSuccess,
        deleteError: m.course_attachments_messages_deleteError,
        deleting: m.course_attachments_messages_deleting,
        urlCopied: m.course_attachments_messages_urlCopied,
        copyFailed: m.course_attachments_messages_copyFailed,
        clipboardNotSupported: m.course_attachments_messages_clipboardNotSupported,
        fetchError: m.course_attachments_messages_fetchError,
        fillRequired: m.course_attachments_messages_fillRequired,
        saveCourseFirst: m.course_attachments_messages_saveCourseFirst
    }
};
// ========== Custom Blocks Messages ==========
export const customBlocksMessages = {
    title: m.course_customBlocks_title,
    pageTitle: m.course_customBlocks_pageTitle,
    description: m.course_customBlocks_description,
    dependency: m.course_customBlocks_dependency,
    features: {
        title: m.course_customBlocks_features_title,
        creation: m.course_customBlocks_features_creation,
        examples: m.course_customBlocks_features_examples,
        tutorials: m.course_customBlocks_features_tutorials
    }
};
// ========== Unified Course i18n Object ==========
export const courseI18n = {
    course: courseMessages,
    courses: courseListMessages,
    courseDetail: courseDetailMessages,
    lecture: lectureMessages,
    roadmaps: roadmapsMessages,
    attachments: attachmentsMessages,
    customBlocks: customBlocksMessages
};
// ========== Course Resources (Backward Compatibility) ==========
export const courseResources = courseI18n;
// ========== Course Translation Hook ==========
/**
 * Course feature 전용 번역 훅
 * 
 * @example
 * ```tsx
 * const { course, courses, lecture } = useCourseTranslation();
 * 
 * // 사용 예시
 * <h1>{course.title()}</h1>
 * <p>{courses.loading()}</p>
 * <span>{lecture.title()}</span>
 * ```
 */ export const useCourseTranslation = ()=>courseI18n;
// ========== Direct Message Exports (원본 호환성) ==========
export { courseMessages as course, courseListMessages as courses, courseDetailMessages as courseDetail, lectureMessages as lecture, roadmapsMessages as roadmaps, attachmentsMessages as attachments, customBlocksMessages as customBlocks };
